import { Component, OnInit } from '@angular/core';
import { InspectionSiteSupplierService, OrganisationsService } from '../../../services';
import { ButtonModule, ConfirmationService, SelectItem } from 'primeng';
import { FormControl, FormGroup } from '@angular/forms';
import { TaskType } from '../../../enums/task.type';
import { IInspectionSiteSupplier } from '../../../interfaces/inspections/inspection-site-supplier';
import { IOrganisationInfo } from '../../../interfaces/organisation-info';
import { NgIf } from '@angular/common';
import { VmeCommonModule } from '../../../vme-common.module';
import { VmePipesModule } from '../../../vme-pipes.module';

@Component({
  selector: 'inspection-site-supplier',
  templateUrl: './inspection-site-supplier.component.html',
  styleUrls: ['./inspection-site-supplier.component.scss'],
  standalone: true,
  imports: [ButtonModule, NgIf, VmeCommonModule, VmePipesModule],
})
export class InspectionSiteSupplierComponent implements OnInit {
  isLoaded = false;
  inspectionSiteSuppliers: IInspectionSiteSupplier[] = [];
  siteSupplierSelected = null;
  createEditForm: FormGroup;
  editMode: boolean;
  showForm: boolean;
  suppliers: SelectItem[];

  constructor(
    private inspectionSiteSupplierService: InspectionSiteSupplierService,
    private confirmationService: ConfirmationService,
    private organisationService: OrganisationsService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadInspectionSiteSuppliers();
    this.loadSuppliers();
  }

  initForm(): void {
    this.createEditForm = new FormGroup({
      id: new FormControl(),
      siteCode: new FormControl(),
      siteName: new FormControl(),
      supplierId: new FormControl(),
      supplierName: new FormControl(),
    });
  }

  loadInspectionSiteSuppliers(): void {
    this.isLoaded = false;

    this.inspectionSiteSupplierService.search().then((x) => {
      this.inspectionSiteSuppliers = x;

      this.showForm = false;
      this.isLoaded = true;
    });
  }

  loadSuppliers(): void {
    this.organisationService.getOrganisationInfoByTaskType(TaskType.Inspection).then((x) => {
      this.suppliers = x.map((organisationInfo: IOrganisationInfo) => {
        return { label: organisationInfo.name, value: organisationInfo.id };
      });

      this.suppliers.unshift({ label: 'None', value: null });
    });
  }

  createSiteSupplier(): void {
    this.showForm = true;
    this.editMode = false;
    this.createEditForm.reset();
  }

  deleteSiteSupplier(): void {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this site supplier?',
      header: 'Confirmation',
      icon: 'pi pi-question',
      accept: () => {
        this.deleteConfirmed();
      },
    });
  }

  deleteConfirmed(): void {
    this.inspectionSiteSupplierService
      .deleteInspectionSiteSupplier(this.siteSupplierSelected.id)
      .then((x) => {
        this.siteSupplierSelected = null;
        this.loadInspectionSiteSuppliers();
      });
  }

  editSiteSupplier(item): void {
    this.showForm = true;
    this.siteSupplierSelected = item;
    this.editMode = true;
    this.createEditForm.patchValue(item);
  }

  save(): void {
    if (this.createEditForm.get('id').value > 0) {
      this.inspectionSiteSupplierService
        .updateInspectionSiteSupplier(this.createEditForm.value)
        .then((x) => {
          this.loadInspectionSiteSuppliers();
        });
    } else {
      this.inspectionSiteSupplierService
        .createInspectionSiteSupplier(this.createEditForm.value)
        .then((x) => {
          this.loadInspectionSiteSuppliers();
        });
    }
  }
}
